/* eslint-disable react/prop-types */
/* eslint-disable arrow-body-style */
import PropTypes from 'prop-types';
import React from 'react';
import { Container } from 'reactstrap';
import FooterPartners from './Elements/FooterPartners';
import FooterNavigation from './Elements/FooterNavigation';
import './index.scss';

const Footer = ({ data, partnerLogosData }) => (
  <Container className="py-5" id="footer" fluid style={{ borderTop: '0' }}>
    <FooterNavigation items={data} />
    <hr />
    <FooterPartners partnerLogosData={partnerLogosData} />
  </Container>
);

const linkPropType = PropTypes.shape({
  link: PropTypes.string.isRequired,
  newTab: PropTypes.bool,
  source: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
});

const dataType = PropTypes.shape({
  listClassName: PropTypes.string,
  links: PropTypes.arrayOf(linkPropType).isRequired,
});

Footer.propTypes = {
  data: PropTypes.arrayOf(dataType).isRequired,
};

export default Footer;
